export default "__VITE_ASSET__BPa91kIT__"